export default "__VITE_ASSET__GuJgRPY4__"